<template>
    <div class="form-group customebtnrow">
        <v-select label="text" :filterable="false"
                  v-model="vendorForm.vendor"
                  :options="vendors"
                  :multiple="multiple"
                  @search="onVendorSearch"
                  @input="onVendorSelect"
                  @selected="onVendorSelect"
                  @deselected ="onVendorDeSelect">
            <template slot="no-options">
                type to search vendors..
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center" v-html="option.html">
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center" v-html="option.text">
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
import axios from "axios";
import {mapActions} from "vuex";

export default {
    name: "VendorSelect",
    props:{
        vendor: {
            type: Object,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if(this.vendor) {
            this.vendorForm.vendor_id = this.vendor_id;

            let html = '<div>' + this.vendor.company_name + '</div>';
            if(this.vendor.vendor_contacts.length) {
                html = '<div>' + this.vendor.vendor_contacts[0].contact_name + '</div>' + '<div class="short_text">Company:'+ this.vendor.company_name + '</div>';
            }
            this.vendorForm.vendor = {
                id: this.vendor.id,
                text: '<div>' + this.vendor.company_name + '</div>',
                name: '<div>' + this.vendor.company_name + '</div>',
                html: html,
            };
        }
    },
    data() {
        return {
            vendorForm: {
                vendor: null,
                vendor_id: null,
            },
            vendors: [],
            vendorData: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        onVendorSelect(event){
            if(!this.multiple) {
                if (event) {
                    this.vendorForm.vendor_id = event.id;
                } else {
                    this.vendorForm.vendor_id = null;
                }
            }
            this.$emit('vendorSelectedEvent', event);
        },
        onVendorDeSelect(event){
            if(!this.multiple) {
                this.vendorForm.vendor_id = null;
            }
            this.$emit('vendorSelectedEvent', event);
        },
        onVendorSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchVendorNew(loading, search, this);
            }
        },
        searchVendorNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchVendors'), {searchTerm: search}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.vendors = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
    },
}
</script>

<style scoped>

</style>
